import { Component, Input } from '@angular/core';
import { MovieElementPreviewFragment } from '@/core/graphql/graphql';

@Component({
  selector: 'cosmos-movie-element-preview',
  templateUrl: './movie-element-preview.component.html',
  styleUrls: ['./movie-element-preview.component.scss'],
})
export class MovieElementPreviewComponent {
  @Input() public element: MovieElementPreviewFragment;
}
